import { PropsWithChildren } from 'react';
import { useRedirectHandler } from '@antimatterhq/ui/hooks/auth/useRedirectHandler';
import { RedirectErrorMessage } from '@antimatterhq/ui/components/redirectError';
import { PageHeader } from '@/components/pageHeader/PageHeader';
import { useClientAuthentication } from '@/hooks/authentication/useClientAuthentication';

export default function RedirectHandler({ children }: PropsWithChildren) {
  const { refreshAuthentication } = useClientAuthentication();

  const { isCheckingRedirect, redirectError } = useRedirectHandler({
    prefix: 'client',
  });

  if (redirectError) {
    return (
      <main className="flex h-screen w-screen flex-col items-center justify-center gap-4 p-4">
        <PageHeader pageTitle="" />
        <RedirectErrorMessage
          error={redirectError}
          initiateAuthentication={refreshAuthentication}
          prefix="client"
        />
      </main>
    );
  }

  return (
    <>
      {isCheckingRedirect === undefined || isCheckingRedirect === true
        ? null
        : children}
    </>
  );
}
